import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Modular imports
import { commonEn } from './i18n/en/common';
import { commonEs } from './i18n/es/common';
import { dashboardEn } from './i18n/en/dashboard';
import { dashboardEs } from './i18n/es/dashboard';
import { frostEn } from './i18n/en/frost';
import { frostEs } from './i18n/es/frost';
import { irrigationEn } from './i18n/en/irrigation';
import { irrigationEs } from './i18n/es/irrigation';
import { cropHealthEn, pestCanonicalEn } from './i18n/en/cropHealth';
import { cropHealthEs, pestCanonicalEs } from './i18n/es/cropHealth';
import { diseaseRiskEn } from './i18n/en/diseaseRisk';
import { diseaseRiskEs } from './i18n/es/diseaseRisk';
import { notificationsEn } from './i18n/en/notifications';
import { notificationsEs } from './i18n/es/notifications';
import { parcelsEn } from './i18n/en/parcels';
import { parcelsEs } from './i18n/es/parcels';
import { satelliteEn } from './i18n/en/satellite';
import { satelliteEs } from './i18n/es/satellite';
import { analyticsEn } from './i18n/en/analytics';
import { analyticsEs } from './i18n/es/analytics';
import { alertsEn } from './i18n/en/alerts';
import { alertsEs } from './i18n/es/alerts';
import { insuranceEn } from './i18n/en/insurance';
import { insuranceEs } from './i18n/es/insurance';
import { marketplaceEn } from './i18n/en/marketplace';
import { marketplaceEs } from './i18n/es/marketplace';
import { marketEn } from './i18n/en/market';
import { marketEs } from './i18n/es/market';
import { landingEn } from './i18n/en/landing';
import { landingEs } from './i18n/es/landing';
import { pagesEn } from './i18n/en/pages';
import { pagesEs } from './i18n/es/pages';
import { aboutEn } from './i18n/en/about';
import { aboutEs } from './i18n/es/about';
import { registerEn } from './i18n/en/register';
import { registerEs } from './i18n/es/register';
import { blogEn } from './i18n/en/blog';
import { blogEs } from './i18n/es/blog';
import { defiEn } from './i18n/en/defi';
import { defiEs } from './i18n/es/defi';
import { mobileAppEn } from './i18n/en/mobileApp';
import { mobileAppEs } from './i18n/es/mobileApp';
import { architectureEn } from './i18n/en/architecture';
import { architectureEs } from './i18n/es/architecture';
import { fao56En } from './i18n/en/fao56';
import { fao56Es } from './i18n/es/fao56';
import { cooperativeEn } from './i18n/en/cooperative';
import { cooperativeEs } from './i18n/es/cooperative';
import { passportEn } from './i18n/en/passport';
import { passportEs } from './i18n/es/passport';
import { advancedToolsEn } from './i18n/en/advancedTools';
import { advancedToolsEs } from './i18n/es/advancedTools';
import { certificationEn } from './i18n/en/certification';
import { certificationEs } from './i18n/es/certification';
import { firePropagationEn } from './i18n/en/firePropagation';
import { firePropagationEs } from './i18n/es/firePropagation';
import { golfEn } from './i18n/en/golf';
import { golfEs } from './i18n/es/golf';
import { componentsEn } from './i18n/en/components';
import { componentsEs } from './i18n/es/components';
import { solutionsEn } from './i18n/en/solutions';
import { solutionsEs } from './i18n/es/solutions';
import { advisorEn } from './i18n/en/advisor';
import { advisorEs } from './i18n/es/advisor';
import { gauchoEn } from './i18n/en/gaucho';
import { gauchoEs } from './i18n/es/gaucho';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          ...commonEn,
          ...dashboardEn,
          ...frostEn,
          ...irrigationEn,
          ...cropHealthEn,
          ...pestCanonicalEn,
          ...diseaseRiskEn,
          ...notificationsEn,
          ...parcelsEn,
          ...satelliteEn,
          ...analyticsEn,
          ...alertsEn,
          ...insuranceEn,
          ...marketplaceEn,
          ...marketEn,
          ...landingEn,
          ...pagesEn,
          ...aboutEn,
          ...registerEn,
          ...blogEn,
          ...defiEn,
          ...mobileAppEn,
          ...architectureEn,
          ...fao56En,
          ...cooperativeEn,
          ...passportEn,
          ...advancedToolsEn,
          ...certificationEn,
          ...firePropagationEn,
          ...golfEn,
          ...componentsEn
          ,...solutionsEn
          ,...advisorEn
          ,...gauchoEn
        }
      },
      es: {
        translation: {
          ...commonEs,
          ...dashboardEs,
          ...frostEs,
          ...irrigationEs,
          ...cropHealthEs,
          ...pestCanonicalEs,
          ...diseaseRiskEs,
          ...notificationsEs,
          ...parcelsEs,
          ...satelliteEs,
          ...analyticsEs,
          ...alertsEs,
          ...insuranceEs,
          ...marketplaceEs,
          ...marketEs,
          ...landingEs,
          ...pagesEs,
          ...aboutEs,
          ...registerEs,
          ...blogEs,
          ...defiEs,
          ...mobileAppEs,
          ...architectureEs,
          ...fao56Es,
          ...cooperativeEs,
          ...passportEs,
          ...advancedToolsEs,
          ...certificationEs,
          ...firePropagationEs,
          ...golfEs,
          ...componentsEs
          ,...solutionsEs
          ,...advisorEs
          ,...gauchoEs
        }
      }
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'selectedLanguage',
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
